
export const getCurrentUser = (state) => state.currentUser



// WEBPACK FOOTER //
// ./selectors/current-user.js